/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TitreDiplomeCertificationGridDto
 */
export interface TitreDiplomeCertificationGridDto {
    /**
     * 
     * @type {number}
     * @memberof TitreDiplomeCertificationGridDto
     */
    idtitreDiplomeCertification?: number;
    /**
     * 
     * @type {string}
     * @memberof TitreDiplomeCertificationGridDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TitreDiplomeCertificationGridDto
     */
    actif?: boolean | null;
}

/**
 * Check if a given object implements the TitreDiplomeCertificationGridDto interface.
 */
export function instanceOfTitreDiplomeCertificationGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TitreDiplomeCertificationGridDtoFromJSON(json: any): TitreDiplomeCertificationGridDto {
    return TitreDiplomeCertificationGridDtoFromJSONTyped(json, false);
}

export function TitreDiplomeCertificationGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TitreDiplomeCertificationGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idtitreDiplomeCertification': !exists(json, 'idtitreDiplomeCertification') ? undefined : json['idtitreDiplomeCertification'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
    };
}

export function TitreDiplomeCertificationGridDtoToJSON(value?: TitreDiplomeCertificationGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idtitreDiplomeCertification': value.idtitreDiplomeCertification,
        'description': value.description,
        'actif': value.actif,
    };
}

